const defaultWidth = 40;
const defaultHeight = 40;

export const IllustSubscriptionUser = ({ width = defaultWidth, height = defaultHeight }: SvgProps) => {
  return (
    <svg width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g transform={`scale(${width / defaultWidth}, ${height / defaultHeight})`}>
        <path d="M10 9.5L9.5 23.5L30.5 24V9.5H10Z" fill="#E1E4E8" />
        <rect x="9.13325" y="9.1335" width="21.7333" height="14.7333" rx="1.2" stroke="#24292E" strokeWidth="1.6" />
        <rect x="10.6667" y="26.7998" width="18.6667" height="1.6" rx="0.8" fill="#24292E" />
        <rect x="13" y="30.3999" width="14" height="1.6" rx="0.8" fill="#24292E" />
        <path
          d="M23.6741 13.1357C23.9881 12.8218 24.4968 12.8217 24.8108 13.1357C25.1248 13.4498 25.1248 13.9584 24.8108 14.2725L19.261 19.8232C19.108 19.9763 18.8992 20.061 18.6829 20.0586C18.4666 20.0561 18.2601 19.9669 18.1106 19.8105L15.4563 17.0352C15.1494 16.7142 15.1608 16.2054 15.4817 15.8984C15.8027 15.5914 16.3114 15.6029 16.6184 15.9238L18.7043 18.1035L23.6741 13.1357Z"
          fill="#24292E"
          stroke="#24292E"
          strokeWidth="0.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="29.01" cy="28.01" r="6.51" fill="#24292E" stroke="white" />
        <path
          d="M31.981 27.64C32.1698 27.8289 32.1698 28.1346 31.981 28.3236L29.9156 30.389C29.7267 30.5779 29.4204 30.5785 29.2313 30.3897C29.0423 30.2007 29.0423 29.8937 29.2313 29.7047L30.4701 28.4658H26.3615C26.0942 28.4658 25.8774 28.2491 25.8774 27.9818C25.8774 27.7145 26.0942 27.4977 26.3615 27.4977H30.4701L29.2313 26.2589C29.0423 26.0699 29.0423 25.7629 29.2313 25.5739C29.4204 25.385 29.7267 25.3856 29.9156 25.5746L31.981 27.64Z"
          fill="white"
          stroke="white"
          strokeWidth="0.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
